import { apiClient, safeApi } from '../../utils/axiosWithAuth';
import { ApiResponse } from '../../utils/axiosWithAuth';
import {
  DemandDTO,
  DemandInvoiceDTO,
  CreateDemandPayload,
  UpdateDemandPayload,
  ProcessDemandPayload,
  DemandPaginationResponse,
  DemandQueryParams,
} from '../../types/demand';

export const createDemandAPI = (dto: CreateDemandPayload) =>
  safeApi<DemandDTO>(() =>
    apiClient.post<ApiResponse<DemandDTO>>('/demands', dto)
  );

export const fetchDemandsAPI = (params: DemandQueryParams = {}) =>
  safeApi<DemandPaginationResponse>(() => {
    const queryParams = new URLSearchParams();

    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    if (params.search) queryParams.append('search', params.search);
    if (params.status) queryParams.append('status', params.status);
    if (params.requestType) queryParams.append('requestType', params.requestType);
    if (params.storeId) queryParams.append('storeId', params.storeId);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    if (params.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);

    return apiClient.get<ApiResponse<DemandPaginationResponse>>(
      `/demands?${queryParams.toString()}`
    );
  });

export const fetchOneDemandAPI = (uuid: string) =>
  safeApi<DemandDTO>(() =>
    apiClient.get<ApiResponse<DemandDTO>>(`/demands/${uuid}`)
  );

export const updateDemandAPI = (uuid: string, dto: UpdateDemandPayload) =>
  safeApi<DemandDTO>(() =>
    apiClient.put<ApiResponse<DemandDTO>>(`/demands/${uuid}`, dto)
  );

export const deleteDemandAPI = (uuid: string) =>
  safeApi<{ deleted: boolean }>(() =>
    apiClient.delete<ApiResponse<{ deleted: boolean }>>(`/demands/${uuid}`)
  );

export const processDemandAPI = (uuid: string, dto: ProcessDemandPayload) =>
  safeApi<DemandDTO>(() =>
    apiClient.put<ApiResponse<DemandDTO>>(`/demands/${uuid}/process`, dto)
  );

export const fetchDemandInvoicesAPI = (demandUuid: string) =>
  safeApi<DemandInvoiceDTO[]>(() =>
    apiClient.get<ApiResponse<DemandInvoiceDTO[]>>(
      `/demands/${demandUuid}/invoices`
    )
  );

export const fetchAllInvoicesAPI = (params: DemandQueryParams = {}) =>
  safeApi<any>(() => {
    const queryParams = new URLSearchParams();

    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    if (params.search) queryParams.append('search', params.search);
    if (params.storeId) queryParams.append('storeId', params.storeId);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);

    return apiClient.get<ApiResponse<any>>(
      `/demands/invoices/all?${queryParams.toString()}`
    );
  });

export const fetchOneInvoiceAPI = (invoiceUuid: string) =>
  safeApi<DemandInvoiceDTO>(() =>
    apiClient.get<ApiResponse<DemandInvoiceDTO>>(
      `/demands/invoices/${invoiceUuid}`
    )
  );

// Search inventory items for demand creation
export const searchInventoryItemsAPI = (query: string) =>
  safeApi<any[]>(() =>
    apiClient.get<ApiResponse<any[]>>(
      `/inventory/items?search=${encodeURIComponent(query)}&limit=20`
    )
  );
